/* MARLUPS — script tema (jQuery + slick richiesti) */
(function(){
  const menuBtn=document.querySelector(".site-header__menu-nav"),
        overlay=document.querySelector(".site-header__overlay"),
        drawer=document.querySelector(".site-header__drawer"),
        closeBtn=document.querySelector(".site-header__menu-close"),
        body=document.body,
        header=document.querySelector(".site-header");
  if(!header) return;
  function openDrawer(){ if(drawer) drawer.classList.add("open"); if(overlay) overlay.classList.add("show"); body.classList.add("no-scroll"); }
  function closeDrawer(){ if(drawer) drawer.classList.remove("open"); if(overlay) overlay.classList.remove("show"); body.classList.remove("no-scroll"); }
  if(menuBtn) menuBtn.onclick=openDrawer;
  if(overlay) overlay.onclick=closeDrawer;
  if(closeBtn) closeBtn.onclick=closeDrawer;
  const headerHeight=header.offsetHeight;
  window.addEventListener("scroll",()=>{
    if(window.scrollY>40){ header.classList.add("sticky"); body.style.paddingTop=headerHeight+"px"; }
    else { header.classList.remove("sticky"); body.style.paddingTop=""; }
  });
})();
document.addEventListener("DOMContentLoaded",function(){const items=document.querySelectorAll(".faq-accordion__item");items.forEach(item=>{const trigger=item.querySelector(".faq-accordion__item-title"),content=item.querySelector(".faq-accordion__item-description");content.style.height="0px",content.style.overflow="hidden",content.style.paddingBottom="0px",trigger.addEventListener("click",()=>{const isOpen=item.classList.contains("is-open");if(items.forEach(otherItem=>{const otherContent=otherItem.querySelector(".faq-accordion__item-description");otherItem!==item&&(otherItem.classList.remove("is-open"),otherContent.style.height="0px",otherContent.style.paddingBottom="0px")}),isOpen)content.style.height="0px",content.style.paddingBottom="0px",item.classList.remove("is-open");else{item.classList.add("is-open"),content.style.height="auto";const fullHeight=content.scrollHeight+"px";content.style.height="0px",requestAnimationFrame(()=>{content.style.height=fullHeight,content.style.paddingBottom="20px"})}})})});
document.addEventListener("DOMContentLoaded",()=>{const counters=document.querySelectorAll(".progress-counter__item-counter"),animateCount=(el,target)=>{const startTime=performance.now(),step=currentTime=>{const progress=Math.min((currentTime-startTime)/1500,1),value=Math.floor(progress*target);el.textContent=value+"%",progress<1?requestAnimationFrame(step):el.textContent=target+"%"};requestAnimationFrame(step)},observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){const el=entry.target,targetValue=parseInt(el.getAttribute("data-percentage"),10);el.classList.contains("counted")||(el.classList.add("counted"),animateCount(el,targetValue))}})},{threshold:.5});counters.forEach(counter=>observer.observe(counter))});
document.addEventListener("DOMContentLoaded",()=>{const journeyItems=document.querySelectorAll(".progress-timeline__item");let lastScrollY=window.scrollY,queue=[],processing=!1;const processQueue=()=>{if(processing||queue.length===0)return;processing=!0,queue.shift().classList.add("active"),setTimeout(()=>{processing=!1,processQueue()},800)},observer=new IntersectionObserver(entries=>{const currentScrollY=window.scrollY,isScrollingDown=currentScrollY>lastScrollY;entries.forEach(entry=>{const target=entry.target;entry.isIntersecting?!target.classList.contains("active")&&!queue.includes(target)&&(queue.push(target),processQueue()):isScrollingDown||target.classList.remove("active")}),lastScrollY=currentScrollY},{threshold:1});journeyItems.forEach(item=>observer.observe(item))});
$(window).on('load', function () {
  $(".review-slider__contents").slick({slidesToShow:3,slidesToScroll:1,arrows:!0,dots:!0,infinite:!1,prevArrow:$(".review-slider__button.btn-prev"),nextArrow:$(".review-slider__button.btn-next"),responsive:[{breakpoint:980,settings:{slidesToShow:2}},{breakpoint:580,settings:{slidesToShow:1}}]});
  $(window).trigger('resize');
});

$(window).on('load', function () {
  $(".product-offer__main-slider").slick({slidesToShow:1,slidesToScroll:1,arrows:!1,dots:!1,infinite:!0,asNavFor:".product-offer__nav-slider"});
  $(".product-offer__nav-slider").slick({slidesToShow:5,slidesToScroll:1,asNavFor:".product-offer__main-slider",dots:!1,focusOnSelect:!0,infinite:!0,arrows:!0,prevArrow:$(".product-offer__button-carousel.btn-prev"),nextArrow:$(".product-offer__button-carousel.btn-next")});
  $(window).trigger('resize');
});

document.addEventListener("DOMContentLoaded", () => {
  const variantItems = document.querySelectorAll(".product-offer__variant-item");
  const variantInput = document.getElementById("selected-variant-id");
  const buyNowBtn = document.getElementById("buy-now");
  if (!buyNowBtn) return;
  const form = buyNowBtn.closest("form");
  const subscriptionWrapper = document.getElementById("subscription-wrapper");
  const checklistWrapper = document.querySelector(".product-offer__info-checklist");
  const checklistItems = checklistWrapper ? checklistWrapper.querySelectorAll(".product-offer__checklist-item .value") : [];
  const buyOnceBtn = document.getElementById("product-offer__buy-once-btn");
  const subscriptionCheckbox = document.getElementById("offer-subscription");
  const btnPrice = buyNowBtn.querySelector(".btn-price");
  const btnCompare = buyNowBtn.querySelector(".btn-compare");
  if (form) form.addEventListener("submit", e => e.preventDefault());

  function updatePrices() {
    const selected = document.querySelector(".product-offer__variant-item.selected");
    if (!selected) return;
    const hasSellingPlan = !!selected.dataset.sellingPlanId;
    if (subscriptionWrapper) {
      if (hasSellingPlan) subscriptionWrapper.classList.remove("hidden-display");
      else { if (subscriptionCheckbox) subscriptionCheckbox.checked = false; subscriptionWrapper.classList.add("hidden-display"); }
    }
    const isSub = subscriptionCheckbox && subscriptionCheckbox.checked && hasSellingPlan;
    variantItems.forEach(item => {
      const priceEl = item.querySelector(".price");
      const compareEl = item.querySelector(".compare-price");
      const savingEl = item.querySelector(".product-offer__variant-saving");
      const price = isSub ? item.dataset.subscriptionPrice : item.dataset.price;
      const savings = isSub ? item.dataset.savingsSub : item.dataset.savings;
      if (priceEl) priceEl.textContent = price;
      if (savingEl && savings) savingEl.textContent = savings;
      if (compareEl) compareEl.textContent = item.dataset.comparePrice;
    });
    const activePrice = isSub ? selected.dataset.subscriptionPrice : selected.dataset.price;
    if (btnPrice) btnPrice.textContent = activePrice;
    if (btnCompare) {
      if (selected.dataset.comparePrice) { btnCompare.textContent = selected.dataset.comparePrice; btnCompare.style.display = "inline"; }
      else btnCompare.style.display = "none";
    }
  }

  function updateChecklist() {
    if (!checklistItems.length) return;
    const selected = document.querySelector(".product-offer__variant-item.selected");
    if (!selected) return;
    const selectedIndex = Array.from(variantItems).indexOf(selected);
    checklistItems.forEach(item => {
      const rawText = item.dataset.originalValue || item.textContent.trim();
      if (!item.dataset.originalValue) item.dataset.originalValue = rawText;
      const parts = rawText.split("|").map(p => p.trim());
      if (parts.length === 1) { item.textContent = parts[0]; item.closest(".product-offer__checklist-item").style.display = ""; return; }
      if (parts[selectedIndex]) { item.textContent = parts[selectedIndex]; item.closest(".product-offer__checklist-item").style.display = ""; }
      else item.closest(".product-offer__checklist-item").style.display = "none";
    });
  }

  variantItems.forEach(item => {
    item.addEventListener("click", () => {
      variantItems.forEach(v => v.classList.remove("selected"));
      item.classList.add("selected");
      if (variantInput) variantInput.value = item.dataset.id;
      updatePrices(); updateChecklist();
    });
  });
  if (subscriptionCheckbox) subscriptionCheckbox.addEventListener("change", updatePrices);

  [buyNowBtn, buyOnceBtn].forEach(btn => btn && btn.addEventListener("click", async e => {
    e.preventDefault();
    const variantId = variantInput && variantInput.value;
    if (!variantId) return;
    btn.classList.add("loading");
    btn.setAttribute("disabled", true);
    try {
      await fetch("/cart/clear.js", { method: "POST" });
      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });
      window.location.href = "/checkout";
    } catch (err) {
      console.error(err);
      btn.classList.remove("loading");
      btn.removeAttribute("disabled");
    }
  }));

  window.addEventListener("pageshow", () => {
    [buyNowBtn, buyOnceBtn].forEach(b => { if (b) { b.classList.remove("loading"); b.disabled = false; } });
  });

  updatePrices(); updateChecklist();
});

document.addEventListener("DOMContentLoaded", function () {
  const stockMsg = document.querySelector(".product-offer__stock-message");
  if (!stockMsg) return;
  const daysToAdd = parseInt(stockMsg.getAttribute("data-days"), 10) || 3;
  const futureDate = new Date();
  futureDate.setDate(futureDate.getDate() + daysToAdd);
  const mesi = ["gennaio","febbraio","marzo","aprile","maggio","giugno","luglio","agosto","settembre","ottobre","novembre","dicembre"];
  const innerSpan = stockMsg.querySelector("span");
  if (innerSpan) innerSpan.innerHTML += ` <span class="date">${futureDate.getDate()} ${mesi[futureDate.getMonth()]}</span>`;
});

document.addEventListener("DOMContentLoaded", function () {
  const stickyDiv = document.querySelector(".product-offer__sticky");
  const wrapper = document.querySelector(".product-offer__wrapper");
  const footer = document.querySelector(".site-footer");
  if (!stickyDiv || !wrapper || !footer) return;
  const stickyBtn = stickyDiv.querySelector(".product-offer__sticky-btn");
  function handleScroll() {
    const wrapperRect = wrapper.getBoundingClientRect();
    const footerRect = footer.getBoundingClientRect();
    const stickyRect = stickyDiv.getBoundingClientRect();
    const hasPassedWrapper = wrapperRect.bottom <= 0;
    const footerIsTouching = stickyRect.bottom >= footerRect.top;
    if (hasPassedWrapper && !footerIsTouching) stickyDiv.classList.add("visible");
    else stickyDiv.classList.remove("visible");
  }
  window.addEventListener("scroll", handleScroll);
  if (stickyBtn) stickyBtn.addEventListener("click", function (e) {
    e.preventDefault();
    const target = document.querySelector("#product-offer");
    if (target) target.scrollIntoView({ behavior: "smooth" });
  });
  handleScroll();
});

// Slider testimonianze (sezione review-section)
$(window).on('load', function () {
  $('.custom-testimonial-slider').slick({
    slidesToShow: 1, slidesToScroll: 1, infinite: true, centerMode: true, arrows: true,
    prevArrow: '<button type="button" class="custom-testimonial-arrow custom-testimonial-prev"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 7H3.83L9.42 1.41L8 0L0 8L8 16L9.41 14.59L3.83 9H16V7Z" fill="#31A930"/></svg></button>',
    nextArrow: '<button type="button" class="custom-testimonial-arrow custom-testimonial-next"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z" fill="#31A930"/></svg></button>',
    responsive: [{ breakpoint: 990, settings: { slidesToShow: 1, centerMode: false } }]
  });
});

// Scroll ai bundle
document.querySelectorAll('.scroll-on-buy-more-bundle').forEach((button) => {
  button.addEventListener('click', function (e) {
    e.preventDefault();
    const target = document.querySelector('#product-offer');
    if (!target) return;
    const header = document.querySelector('header, .site-header, .sticky-header');
    const headerHeight = header ? header.offsetHeight : 0;
    window.scrollTo({ top: target.getBoundingClientRect().top + window.pageYOffset - headerHeight - 10, behavior: 'smooth' });
  });
});
